// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0529ec7d","213":"df5f8a0d","247":"cb1e8bf7","284":"ef4444b8","553":"efeac1a9","627":"147b9256","834":"e8d8e19c","867":"b096ec38","923":"a4ce0591","938":"6c757551"}[chunkId] + ".chunk.js";
};